import { render, staticRenderFns } from "./ExamplesImg.vue?vue&type=template&id=80f7f6a2&scoped=true&"
import script from "./ExamplesImg.vue?vue&type=script&lang=js&"
export * from "./ExamplesImg.vue?vue&type=script&lang=js&"
import style0 from "./ExamplesImg.vue?vue&type=style&index=0&id=80f7f6a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f7f6a2",
  null
  
)

export default component.exports